<template>
  <div class="h-px w-full bg-tertiary-500/18"></div>
</template>
